module.exports = __webpack_public_path__ + "static/media/Quimicos-del-oeste-txt-01.e07bafdc.png";